import { refillOrderTypeFor } from "~/shared/utils/sharedUtils";

import KickClient from "~/visits/utils/api.js";
import {
  clearOrderComplete,
  clearOrderItems,
  clearConsultAnswersJSON,
  setBetaBlockerVariant,
  setConsultationTypeOrderItem,
  setFollowUpVisitFlag,
  setLatestAddress,
  setUserID,
  setVisitEmail,
  setVisitID,
  setVisitPhone,
  setVisitProduct,
} from "~/visits/utils/visitCookies";

import {
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP,
} from "~/shared/sharedConstants";

export function setProperVisitCookies(
  userID,
  visitID,
  orderType,
  email,
  phone,
  address1,
  address2,
  city,
  usState,
  zip
) {
  // TODO: set consultation and order item?
  clearConsultAnswersJSON();
  setVisitProduct(orderType);
  setVisitEmail(email);
  clearOrderComplete();

  if (phone) {
    setVisitPhone(phone.replace(/[-()]/g, "").replace(" ", ""));
  }

  setUserID(userID);
  setVisitID(visitID);
  setLatestAddress({
    address1: address1,
    address2: address2,
    city: city,
    usState: usState,
    zip: zip,
  });
}

export function setCookiesAndRedirectToInsomniaFollowUpVisit(
  userID,
  email,
  phone,
  address1,
  address2,
  city,
  usState,
  zip
) {
  clearOrderItems();
  clearConsultAnswersJSON();

  setProperVisitCookies(
    userID,
    "",
    "",
    email,
    phone,
    address1,
    address2,
    city,
    usState,
    zip
  );
  setFollowUpVisitFlag("yes");
  let consultationType = CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP;

  window.location.href = `/visits/${consultationType}/1`;
}

const followUpConsultationTypeFor = (consultationType) => {
  switch (consultationType) {
    case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY:
      return CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP;
    case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA:
      return CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP;
    default:
      return "";
  }
};

function setRefillOrderItems(orderItems) {
  clearOrderItems();
  (orderItems || []).forEach((orderItem) => {
    const { consultationType, productSlug } = orderItem;
    const followUpConsultationType =
      followUpConsultationTypeFor(consultationType) || consultationType;
    const refillProductSlug = refillOrderTypeFor(productSlug) || productSlug;
    setConsultationTypeOrderItem(followUpConsultationType, refillProductSlug);
  });
}

export function setProperVisitCookiesForRefills(
  { id: userID, email, phone, address1, address2, city, usState, zip }, // patient
  { id: visitID, orderType: originalVisitOrderType, orderItems }, // visit
  { medicationName, medicationDosage } // prescription
) {
  clearOrderItems();
  clearConsultAnswersJSON();

  let refillOrderType = refillOrderTypeFor(originalVisitOrderType);
  setBetaBlockerVariant(`${medicationName} ${medicationDosage}`);
  setProperVisitCookies(
    userID,
    visitID,
    refillOrderType,
    email,
    phone,
    address1,
    address2,
    city,
    usState,
    zip
  );
  setRefillOrderItems(orderItems);
}

export function setCookiesAndRedirectToPerformanceFollowUpVisit(
  patient,
  prescription
) {
  setProperVisitCookiesForFollowUp(patient, prescription);
  const consultationType =
    CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP;

  window.location.href = `/visits/${consultationType}/1`;
}

export function setProperVisitCookiesForFollowUp(
  { id: userID, email, phone, address1, address2, city, usState, zip },
  { medicationName, medicationDosage }
) {
  clearOrderItems();
  clearConsultAnswersJSON();

  setFollowUpVisitFlag("yes");
  setBetaBlockerVariant(`${medicationName} ${medicationDosage}`);
  setProperVisitCookies(
    userID,
    "",
    "",
    email,
    phone,
    address1,
    address2,
    city,
    usState,
    zip
  );
}

export function saveConsultIntake(visitID, consultationType, intake) {
  const path = `/visits/${visitID}/consult-intakes`;
  KickClient.newAuthenticatedClient()
    .post(path, {
      consultationType,
      intake,
    })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      console.error("[saveConsultIntake] Error: ", error);
    });
}
